import RecordTemplates  from "../../../../domain/record/template/RecordTemplates";
import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_RECORD_TEMPLATES = "SET_RECORD_TEMPLATES"
}

export interface SetRecordTemplatesAction extends ResKaReduxAction {
  templates: RecordTemplates;
}

export type RecordTemplatesAction = SetRecordTemplatesAction;

export const setRecordTemplatesAction = (templates: RecordTemplates): SetRecordTemplatesAction => ({
  type: ACTION_TYPE.SET_RECORD_TEMPLATES,
  templates: templates,
});